<template>
  <v-app>
    <div v-if="!loading && isSigned" class="fill-absolute gui-flex scrollable-y" id="page">
      <v-navigation-drawer
        persistent
        :clipped="clipped"
        v-model="drawer"
        enable-resize-watcher
        app
        floating
        temporary
        width="280"
        close-on-click
        class="mobile-drawer"
      >
        <v-list>
          <v-list-tile :to="{ path: '/' }">
            <v-list-tile-title>
              <v-icon class="mr-28">home</v-icon>
              Domů
            </v-list-tile-title>
          </v-list-tile>
          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>book</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Katalog</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/produkty' }">
              <v-list-tile-title>
                <v-icon class="mr-2">description</v-icon>
                Běžné produkty
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/sporici-produkty' }">
              <v-list-tile-title>
                <v-icon class="mr-2">group_work</v-icon>
                Spořící produkty
              </v-list-tile-title>
            </v-list-tile>
            <v-subheader class="mobile-subheader">
              Pravidla slev
            </v-subheader>
            <v-list-tile :to="{ path: '/slevy/jednorazove-nakupy' }">
              <v-list-tile-title>
                Slevy na jednorázové nákupy
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/slevy/poplatky-sporeni' }">
              <v-list-tile-title>
                Slevy z poplatku spoření
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>people</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Klienti</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/klienti' }">
              <v-list-tile-title>
                <v-icon class="mr-2">account_circle</v-icon>
                Seznam klientů
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/prehledy/predani' }">
              <v-list-tile-title>
                <v-icon class="mr-2">work</v-icon>
                Blokace produktů k předání
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/predani-produktu' }">
              <v-list-tile-title>
                <v-icon class="mr-2">store_mall_directory</v-icon>
                Informování a předávání produktů
              </v-list-tile-title>
            </v-list-tile>
            <v-subheader class="mobile-subheader">
              Objednávky
            </v-subheader>
            <!--<v-list-tile :to="{ path: '/objednavky-sporici' }">
              <v-list-tile-title>
                Objednávky spořících produktů
              </v-list-tile-title>
            </v-list-tile>-->
            <v-list-tile :to="{ path: '/objednavky-jednorazove' }">
              <v-list-tile-title>
                <v-icon class="mr-2">add_shopping_cart</v-icon>
                Objednávky jednorázových produktů
              </v-list-tile-title>
            </v-list-tile>
            <v-subheader class="mobile-subheader">
              Přehledy
            </v-subheader>
            <v-list-tile :to="{ path: '/prehledy/sjednana-sporeni' }">
              <v-list-tile-title>
                <v-icon class="mr-2">card_membership</v-icon>
                Přehled sjednaných spoření
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/prehledy/rozesporene-produkty' }">
              <v-list-tile-title>
                <v-icon class="mr-2">featured_play_list</v-icon>
                Přehled rozespořených produktů
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/prehledy/elektronicke-penezenky' }">
              <v-list-tile-title>
                <v-icon class="mr-2">account_balance_wallet</v-icon>
                Přehled elektronických peněženek
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/prehledy/faktury' }">
              <v-list-tile-title>
                <v-icon class="mr-2">attach_money</v-icon>
                Přehled faktur
              </v-list-tile-title>
            </v-list-tile>
            <v-subheader class="mobile-subheader">
              Ostatní
            </v-subheader>
            <v-list-tile :to="{ path: '/vykup/vykup-kovu' }">
              <v-list-tile-title>
                Výkup kovu
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/vykup/drobny-prodej' }">
              <v-list-tile-title>
                Drobný prodej
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>people</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Spolupracovníci</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/spolupracovnici' }">
              <v-list-tile-title>
                <v-icon class="mr-2">supervised_user_circle</v-icon>
                Spolupracovníci
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/fakturace-provizi' }">
              <v-list-tile-title>
                <v-icon class="mr-2">payment</v-icon>
                Fakturace provizí
              </v-list-tile-title>
            </v-list-tile>
            <v-subheader class="mobile-subheader">
              Přehledy
            </v-subheader>
            <v-list-tile :to="{ path: '/admin/obchody-a-provize' }">
              <v-list-tile-title>
                <v-icon class="mr-2">restore</v-icon>
                Obchody a provize
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/prehledy/spolupracovnici' }">
              <v-list-tile-title>
                <v-icon class="mr-2">people</v-icon>
                Přehled spolupracovníků
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>payment</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Platby</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/platby/bankovni-vypis' }">
              <v-list-tile-title>
                <v-icon class="mr-2">account_balance</v-icon>
                Přijaté platby
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/platby/vraceni-plateb' }">
              <v-list-tile-title>
                <v-icon class="mr-2">arrow_back</v-icon>
                Platby k vrácení
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/platby/nezaplacene-objednavky' }">
              <v-list-tile-title>
                <v-icon class="mr-2">timelapse</v-icon>
                Přehled nezaplacených objednávek a&nbsp;splátek
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>local_shipping</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Dodavatelé</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/dodavatele/nova-objednavka' }">
              <v-list-tile-title>
                <v-icon class="mr-2">local_grocery_store</v-icon>
                Nová objednávka
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/dodavatele/nova-objednavka-vyroby' }">
              <v-list-tile-title>
                <v-icon class="mr-2">local_grocery_store</v-icon>
                Nová objednávka výroby
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/dodavatele/objednavky' }">
              <v-list-tile-title>
                <v-icon class="mr-2">local_shipping</v-icon>
                Objednávky dodavatelům
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/dodavatele/seznam' }">
              <v-list-tile-title>
                Seznam dodavatelů
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>store</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Sklady</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/sklad/sklad-hotovych-produktu' }">
              <v-list-tile-title>
                <v-icon class="mr-2">store</v-icon>
                Sklad hotových produktů
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/sklad/pohyby-ve-skladu-hotovych-vyrobku' }">
              <v-list-tile-title>
                <v-icon class="mr-2">swap_vert</v-icon>
                Pohyby ve skladu hotových výrobků
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/sklad/sklad-metal-konto' }">
              <v-list-tile-title>
                <v-icon class="mr-2">store</v-icon>
                Sklad metal konto
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :href="api_url_admin+'sklady/inventura/xlsx'" target="_blank">
              <v-list-tile-title>
                <v-icon class="mr-2">assignment_turned_in</v-icon>
                Podklady pro inventuru
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-tile :to="{ path: '/fixace' }">
            <v-list-tile-title>
              <v-icon class="mr-28">gps_fixed</v-icon>
              Fixace
            </v-list-tile-title>
          </v-list-tile>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Testtools</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/test-tools/nova-platba' }">
              <v-list-tile-title>
                Nová platba
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/log' }">
              <v-list-tile-title>
                Log systému
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/log-eshop-prihlaseni' }">
              <v-list-tile-title>
                Log přihlášení (e-shop)
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/log-prihlaseni' }">
              <v-list-tile-title>
                Log přihlášení (admin)
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/ceny-produktu' }">
              <v-list-tile-title>
                Ceny produktů
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/kariera' }">
              <v-list-tile-title>
                Kariéra
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/parovani' }">
              <v-list-tile-title>
                Párování spolupracovníků
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/test-tools/pocateni-kredity' }">
              <v-list-tile-title>
                Počáteční kredity spolupracovníků
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :href="api_url+'flexibee/vystavit-faktury'" target="_blank">
              <v-list-tile-title>
                Vystavit faktury
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :href="api_url+'flexibee/odeslat-emaily'" target="_blank">
              <v-list-tile-title>
                Odeslat e-maily
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title class="caption">
                Databáze: {{me.databaze}}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>event</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Události</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/udalosti/prehled-udalosti' }">
              <v-list-tile-title>
                Přehled událostí
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/udalosti/typy-udalosti' }">
              <v-list-tile-title>
                Typy událostí
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ path: '/udalosti/skupiny-ucastniky' }">
              <v-list-tile-title>
                Skupiny účastníků
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-list-tile :to="{ path: '/statistiky/obchody' }">
            <v-list-tile-action>
              <v-icon>show_chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Statistiky</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>edit</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Blog</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/blog/kategorie' }">
              <v-list-tile-title>
                Kategorie
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ path: '/blog/prispevky' }">
              <v-list-tile-title>
                Příspěvky
              </v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>videocam</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Videoblog</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile :to="{ path: '/videoblog/kategorie' }">
              <v-list-tile-title>
                Kategorie
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{ path: '/videoblog/prispevky' }">
              <v-list-tile-title>
                Příspěvky
              </v-list-tile-title>
            </v-list-tile>

          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar
        app
        :clipped-left="true"
        class="elevation-0"
        color="blue accent-3 page--toolbar"
        dark
        extension
        :extension-height="20"
      >
        <div class="mobile-menu">
          <v-btn @click.stop="toggleDrawer" flat class="mx-0"><v-icon class="mr-2">menu</v-icon>Menu</v-btn>
          <v-btn color="white" class="mx-0" flat icon :to="{ path: '/' }">
            <v-icon>home</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-menu offset-y>
            <v-btn slot="activator" flat><span>{{ me.cele_jmeno }}</span> <v-icon small class="ml10 tm1">keyboard_arrow_down</v-icon></v-btn>
            <v-list dense>
              <!--<v-list-tile :to="{ path: '/uzivatel/nastaveni' }">
                <v-list-tile-title><v-icon class="mr5">settings</v-icon> <span>Nastavení uživatele</span></v-list-tile-title>
              </v-list-tile>-->
              <v-list-tile @click="signout">
                <v-list-tile-title><v-icon class="mr-2">power_settings_new</v-icon> <span>Odhlásit</span></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>

        <v-toolbar-items class="desktop-menu">
          <v-btn color="white" icon flat :to="{ path: '/' }">
            <v-icon>home</v-icon>
          </v-btn>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>book</v-icon> Katalog</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/produkty' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">description</v-icon>
                  Běžné produkty
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/sporici-produkty' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">group_work</v-icon>
                  Spořící produkty
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Pravidla slev
              </v-subheader>
              <v-list-tile :to="{ path: '/slevy/jednorazove-nakupy' }">
                <v-list-tile-title>
                  Slevy na jednorázové nákupy
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/slevy/poplatky-sporeni' }">
                <v-list-tile-title>
                  Slevy z poplatku spoření
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>people</v-icon> Klienti</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/klienti' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">account_circle</v-icon>
                  Seznam klientů
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/predani' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">work</v-icon>
                  Blokace produktů k předání
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/predani-produktu' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">store_mall_directory</v-icon>
                  Informování a předávání produktů
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Objednávky
              </v-subheader>
              <!--<v-list-tile :to="{ path: '/objednavky-sporici' }">
                <v-list-tile-title>
                  Objednávky spořících produktů
                </v-list-tile-title>
              </v-list-tile>-->
              <v-list-tile :to="{ path: '/objednavky-jednorazove' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">add_shopping_cart</v-icon>
                  Objednávky jednorázových produktů
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Přehledy
              </v-subheader>
              <v-list-tile :to="{ path: '/prehledy/sjednana-sporeni' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">card_membership</v-icon>
                  Přehled sjednaných spoření
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/rozesporene-produkty' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">featured_play_list</v-icon>
                  Přehled rozespořených produktů
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/elektronicke-penezenky' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">account_balance_wallet</v-icon>
                  Přehled elektronických peněženek
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/faktury' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">attach_money</v-icon>
                  Přehled faktur
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Ostatní
              </v-subheader>
              <v-list-tile :to="{ path: '/vykup/vykup-kovu' }">
                <v-list-tile-title>
                  Výkup kovu
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/vykup/drobny-prodej' }">
                <v-list-tile-title>
                  Drobný prodej
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>people</v-icon> Spolupracovníci</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/spolupracovnici' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">supervised_user_circle</v-icon>
                  Spolupracovníci
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/fakturace-provizi' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">payment</v-icon>
                  Fakturace provizí
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Přehledy
              </v-subheader>
              <v-list-tile :to="{ path: '/admin/obchody-a-provize' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">restore</v-icon>
                  Obchody a provize
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/prepocty-provizi' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">money</v-icon>
                  Přepočty provizí
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/prehledy/spolupracovnici' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">people</v-icon>
                  Přehled spolupracovníků
                </v-list-tile-title>
              </v-list-tile>
                <v-list-tile :to="{ path: '/prehledy/karierni-plan' }">
                  <v-list-tile-title>
                    <v-icon class="mr-2">people</v-icon>
                    Kariérní plán
                  </v-list-tile-title>
                </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>payment</v-icon> Platby</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/platby/bankovni-vypis' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">account_balance</v-icon>
                  Přijaté platby
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/platby/vraceni-plateb' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">arrow_back</v-icon>
                  Platby k vrácení
                </v-list-tile-title>
              </v-list-tile>
              <v-subheader>
                Přehledy
              </v-subheader>
              <v-list-tile :to="{ path: '/platby/nezaplacene-objednavky' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">timelapse</v-icon>
                  Přehled nezaplacených objednávek a&nbsp;splátek
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>local_shipping</v-icon> Dodavatelé</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/dodavatele/nova-objednavka' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">local_grocery_store</v-icon>
                  Nová objednávka
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/dodavatele/nova-objednavka-vyroby' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">local_grocery_store</v-icon>
                  Nová objednávka výroby
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/dodavatele/objednavky' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">local_shipping</v-icon>
                  Objednávky dodavatelům
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/dodavatele/seznam' }">
                <v-list-tile-title>
                  Seznam dodavatelů
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>store</v-icon> Sklady</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/sklad/sklad-hotovych-produktu' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">store</v-icon>
                  Sklad hotových produktů
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/sklad/pohyby-ve-skladu-hotovych-vyrobku' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">swap_vert</v-icon>
                  Pohyby ve skladu hotových výrobků
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/sklad/sklad-metal-konto' }">
                <v-list-tile-title>
                  <v-icon class="mr-2">store</v-icon>
                  Sklad metal konto
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :href="api_url_admin+'sklady/inventura/xlsx'" target="_blank">
                <v-list-tile-title>
                  <v-icon class="mr-2">assignment_turned_in</v-icon>
                  Podklady pro inventuru
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn color="white" flat :to="{ path: '/fixace' }"><v-icon class="mr-2" small>gps_fixed</v-icon> Fixace</v-btn>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>event</v-icon> Události</v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/udalosti/prehled-udalosti' }">
                <v-list-tile-title>
                  Přehled událostí
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/udalosti/typy-udalosti' }">
                <v-list-tile-title>
                  Typy událostí
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/udalosti/skupiny-ucastniky' }">
                <v-list-tile-title>
                  Skupiny účastníků
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon class="mr-2" small>edit</v-icon> Blog</v-btn>
            <v-list>
              <v-subheader><v-icon class="mr-2" small>edit</v-icon>BLOG</v-subheader>
              <v-list-tile :to="{ path: '/blog/kategorie' }">
                <v-list-tile-title>
                  Kategorie
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/blog/prispevky' }">
                <v-list-tile-title>
                  Příspěvky
                </v-list-tile-title>
              </v-list-tile>
              <hr class="light mt-2 mb-2">
              <v-subheader><v-icon class="mr-2" small>videocam</v-icon>VIDEOBLOG</v-subheader>
              <v-list-tile :to="{ path: '/videoblog/kategorie' }">
                <v-list-tile-title>
                  Kategorie
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/videoblog/prispevky' }">
                <v-list-tile-title>
                  Příspěvky
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn color="white" flat :to="{ path: '/statistiky/obchody' }"><v-icon small>show_chart</v-icon></v-btn>
          <v-menu offset-y>
            <v-btn color="white" flat slot="activator"><v-icon small>build</v-icon></v-btn>
            <v-list>
              <v-list-tile :to="{ path: '/test-tools/nova-platba' }">
                <v-list-tile-title>
                  Nová platba
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/log' }">
                <v-list-tile-title>
                  Log systému
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/log-eshop-prihlaseni' }">
                <v-list-tile-title>
                  Log přihlášení (e-shop)
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/log-prihlaseni' }">
                <v-list-tile-title>
                  Log přihlášení (admin)
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/ceny-produktu' }">
                <v-list-tile-title>
                  Ceny produktů
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/kariera' }">
                <v-list-tile-title>
                  Kariéra
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/migrace-troyska-unce' }">
                <v-list-tile-title>
                  Migrace TU
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/parovani' }">
                <v-list-tile-title>
                  Párování spolupracovníků
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :to="{ path: '/test-tools/pocateni-kredity' }">
                <v-list-tile-title>
                  Počáteční kredity spolupracovníků
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :href="api_url+'flexibee/vystavit-faktury'" target="_blank">
                <v-list-tile-title>
                  Vystavit faktury
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile :href="api_url+'flexibee/odeslat-emaily'" target="_blank">
                <v-list-tile-title>
                  Odeslat e-maily
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title class="caption">
                  Databáze: {{me.databaze}}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <!--<SearchBar></SearchBar>-->
        <v-spacer></v-spacer>
        <v-toolbar-items class="desktop-menu">
          <v-menu offset-y>
            <v-btn slot="activator" flat><span>{{ me.cele_jmeno }}</span> <v-icon small class="ml10 tm1">keyboard_arrow_down</v-icon></v-btn>
            <v-list dense>
              <!--<v-list-tile :to="{ path: '/uzivatel/nastaveni' }">
                <v-list-tile-title><v-icon class="mr5">settings</v-icon> <span>Nastavení uživatele</span></v-list-tile-title>
              </v-list-tile>-->
              <v-list-tile @click="signout">
                <v-list-tile-title><v-icon class="mr-2">power_settings_new</v-icon> <span>Odhlásit</span></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
      <v-content class="deep-purple darken-4">
        <transition name="slide">
          <router-view :key="$route.path" />
        </transition>
      </v-content>
    </div>
    <SignIn v-if="!loading && !isSigned" @signed="check()"></SignIn>
    <Loader v-if="loading" skin="light"></Loader>
  </v-app>
</template>

<script>

import SignIn from './components/SignIn'
import SearchBar from './components/SearchBar'

export default {
  data: function () {
    return {
      clipped: true,
      drawer: false,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Pojistné události',
      isSigned: false,
      loading: false,
      menu_drawer: false,
      temporary: false,
      pojistne_udalosti: false,
      prohlidky: false
    }
  },
  watch: {
    drawer: function (val) {
      console.log(val);
    },
    $route (to, from){

    }
  },
  mounted: function() {
    window.MenuListener.listen(function($method) {
      if ($method == "show") {
        //this.drawer = true;
      }
      else {
        this.drawer = false;
      }
    }.bind(this));
    //this.drawer = typeof window.API.$cookies.get("cc_com_menu_drawer") !== "undefined" && window.API.$cookies.get("cc_com_menu_drawer") !== null ? (window.API.$cookies.get("cc_com_menu_drawer") == "0" ? false : true) : true;
    this.$nextTick(function () {
      this.check();
    }.bind(this));
  },
  props: {
    registrace: Boolean
  },
  computed: {
    me: function() {
      return window.$me;
    },
    api_url () {
      return window.api.$api_service;
    },
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  methods: {
    check: function() {
      this.loading = true;
      var x = 0; var y = 0;
      try {
        var win = window,
          doc = document,
          docElem = doc.documentElement,
          body = doc.getElementsByTagName('body')[0];
        x = win.innerWidth || docElem.clientWidth || body.clientWidth;
        y = win.innerHeight|| docElem.clientHeight|| body.clientHeight;
      }
      catch ($e) {

      }
      window.API.post("uzivatel", {
        prohlizec: window.MobileDetect.userAgent(),
        zarizeni: window.MobileDetect.tablet() ? 'tablet' : (window.MobileDetect.mobile() ? 'mobil' : 'pc'),
        os: window.MobileDetect.os(),
        rozliseni_sirka: x,
        rozliseni_vyska: y
      }).then(function(body) {
          window.$me = body;
          window.$user = body;
          this.$data.isSigned = typeof body.prihlasen !== "undefined" && body.prihlasen;
          this.loading = false;
      }.bind(this)).catch(function(err) {
          this.$data.isSigned = false;
          this.loading = false;
          console.log(err);
      }.bind(this));
    },
    signout: function() {
      window.API.$setCookie("cc_com_uid", "", { expires: -30, path: "/" });
      window.API.$setCookie("cc_com_token", "", { expires: -30, path: "/" });
      window.location.reload();
    },
    toggleDrawer: function() {
      this.drawer = !this.drawer;
      window.API.$setCookie("cc_com_menu_drawer", this.drawer ? "1" : "0", { expires: 30, path: "/" });
    },
    goToOrg: function(org_id) {
      window.API.$setCookie("cc_com_org", org_id.toString(), { expires: 30, path: "/" });
      window.location.reload();
    }
  },
  components: {
    SignIn, SearchBar
  },
  name: 'App'
}
</script>
<style>
.application.theme--light {
  /*background-color: #78909C !important;*/
  background-color: #F5F7FA;
}
.navigation {
  border-radius: 0;
}
.v-toolbar {
  border-radius: 0 !important;
}
.navigation--info_container {
  background-color: #311B92;
  height: 128px;
}
.background--primary {
  background-color: #F5F7FA !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue